import { readAllData, STORES } from "utility"
import { getByIdOffline } from "./Get_one"
import { buildFullName } from "./queue"

export async function getWaitingListOffline({ page, limit, filters }) {
  let data = await readAllData(STORES.WAITING_LIST)

  // 🧩 Populate patient
  data = await Promise.all(
    data.map(async (item) => {
      let patient = item.patient

      if (!patient && item.patientId) {
        patient = await getByIdOffline(STORES.PATIENTS, item.patientId)
      }

      return {
        ...item,
        patient,
        fullName: patient ? buildFullName(patient) : null,
      }
    }),
  )

  // 🔍 Filter status
  if (filters.status) {
    data = data.filter((i) => i.status === filters.status)
  }

  // 🔍 Filter fullName
  if (filters.fullName) {
    const search = filters.fullName.toLowerCase()
    data = data.filter((i) => i.fullName?.toLowerCase().includes(search))
  }

  // 📄 Pagination
  const totalItems = data.length
  const start = (page - 1) * limit

  return {
    data: data.slice(start, start + limit),
    totalItems,
  }
}
